import { CardType, DebitSpendingLimit } from '@generated-types';
import { cardTypeGet, cardTypePut } from '@utils/query-utils';

import { REST_BASE_URL, REST_BASE_URL_DEBIT_CARDS } from '../common';

export const getDebitCardSpendingLimits = async (cardId: string) =>
    cardTypeGet(CardType.DEBIT)<DebitSpendingLimit>(`${REST_BASE_URL_DEBIT_CARDS}/${cardId}/spending-limit`);

export const setDebitCardSpendingLimits = async (cardId: string, limit: DebitSpendingLimit) =>
    cardTypePut(CardType.DEBIT)(`${REST_BASE_URL_DEBIT_CARDS}/${cardId}/spending-limit`, limit);

export const getDebitProductSpendingLimits = async (productCode: string) =>
    cardTypeGet(CardType.DEBIT)<DebitSpendingLimit>(
        `${REST_BASE_URL}/debit-card-products/${productCode}/spending-limit`,
    );
